import { render, staticRenderFns } from "./CompetitionDetailsListCard.vue?vue&type=template&id=83fec776&scoped=true"
import script from "./CompetitionDetailsListCard.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailsListCard.vue?vue&type=script&lang=js"
import style0 from "./CompetitionDetailsListCard.vue?vue&type=style&index=0&id=83fec776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fec776",
  null
  
)

export default component.exports